import { PopularImages } from "@components/popular-images";
import { CoinsVal } from "@components/icons/coins";
import { ImagesType } from "@features/images/type";
import { useImage } from "@features/images/use-images";
import { Blockquote, Button, Heading, Text } from "@radix-ui/themes";
import { FileInputOrLink } from "@views/app/camera/components/file-input-or-link";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface StudioHaircutProps {
  image: ImagesType;
  onAction: (action: string) => void;
}

export const StudioHaircut = ({ image, onAction }: StudioHaircutProps) => {
  const { t } = useTranslation();
  const [fromImage, setFromImage] = useState<File | string | null>(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const { haircut } = useImage(image.id);

  const handleApplyHaircut = async () => {
    if (!fromImage) return;

    setIsProcessing(true);
    try {
      await haircut(fromImage, 1);
      onAction("apply_haircut");
    } catch (error) {
      console.error("Failed to apply haircut:", error);
    }
    setIsProcessing(false);
  };

  return (
    <div className="space-y-4">
      <Heading size="3">{t("studio.haircut.title")}</Heading>

      <div className="space-y-2">
        <FileInputOrLink
          heading={t("studio.haircut.hairstyle_label")}
          fromImage={fromImage}
          setFromImage={setFromImage}
        />
        <Blockquote size="2">{t("studio.haircut.description")}</Blockquote>
      </div>

      <PopularImages
        type="image_hairstyle"
        onChange={(item) => setFromImage(item.url)}
      />

      <Button
        size="3"
        className="w-full"
        disabled={!fromImage || isProcessing}
        onClick={handleApplyHaircut}
      >
        <CoinsVal val={8} />
        <Text>{t("studio.haircut.apply")}</Text>
      </Button>
    </div>
  );
};
